import { render, staticRenderFns } from "./UseCaseDetailComponent.vue?vue&type=template&id=7f8f4a3e&scoped=true"
import script from "./UseCaseDetailComponent.vue?vue&type=script&lang=js"
export * from "./UseCaseDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8f4a3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8f4a3e')) {
      api.createRecord('7f8f4a3e', component.options)
    } else {
      api.reload('7f8f4a3e', component.options)
    }
    module.hot.accept("./UseCaseDetailComponent.vue?vue&type=template&id=7f8f4a3e&scoped=true", function () {
      api.rerender('7f8f4a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/UseCaseDetailComponent.vue"
export default component.exports